<template>
  <article>
    <div v-if="type==='association'" id="gold-history-section">
      <div v-for="(item, index) in getItems" :key="index">
        <span v-if="item.data.length > 0">
          <h2>{{ item.date | formatThaiDateWithWeekDay }}</h2>
        </span>

        <div v-for="(goldData, index) in item.data" :key="index" class="gold-history-card">
          <div class="gold-card-content-history">
            <div class="left">
              <div class="title-round">ครั้งที่ {{goldData.createdTime}}</div>
              <div class="content">
                <div class="time">
                  <i class="fal fa-clock"></i>
                  {{ goldData.createdAt | formatTime }}
                </div>
              </div>
              <span></span>
            </div>
            <div class="center">
              <div class="title">รับซื้อ</div>
              <div class="content">
                <div
                  class="price"
                >{{ isGoldbar? goldData.barBuyPrice : goldData.ornamentBuyPrice | currency}}</div>
                <div class="unit">{{unitBaht}}</div>
              </div>
              <span
                v-if="type==='association' && isGoldbar"
                class="price-change"
                :class="[priceChangeColor(goldData.barPriceChange)]"
              >
                <i :class="[isPriceChange(goldData.barPriceChange)]"></i>
                {{goldData.barPriceChange | minusValue }}
              </span>
            </div>
            <div class="right">
              <div class="title">ขายออก</div>
              <div class="content">
                <div
                  class="price"
                >{{isGoldbar? goldData.barSellPrice : goldData.ornamentSellPrice | currency}}</div>
                <div class="unit">{{unitBaht}}</div>
              </div>
              <span
                v-if="type==='association' && isGoldbar"
                class="price-change"
                :class="[priceChangeColor(goldData.barPriceChange)]"
              >
                <i :class="[isPriceChange(goldData.barPriceChange)]"></i>
                {{goldData.barPriceChange | minusValue }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="components-loading" v-if="!getItems">
        <i class="fas fa-spinner-third fa-spin"></i>
      </div>
    </div>
    <infinite-loading
      v-if="wantLoaing"
      ref="infiniteLoading"
      spinner="waveDots"
      @infinite="infiniteHandler"
    ></infinite-loading>
  </article>
</template>

<script>
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {},
  props: ["wantLoaing", "type", "dataAction", "dataList", "queryDate", "isGoldbar"],
  data() {
    return {
      unitBaht: "฿",
      items: [
        {
          data: [
            { barBuyPrice: 0 },
            { barPriceChange: 0 },
            { barSellPrice: 0 },
            { createdAt: "loading..." },
            { createdTime: "loading..." },
            { ornamentBuyPrice: 0 },
            { ornamentSellPrice: 0 }
          ],
          date: "loading..."
        },
        {
          data: [
            { barBuyPrice: 0 },
            { barPriceChange: 0 },
            { barSellPrice: 0 },
            { createdAt: "loading..." },
            { createdTime: "loading..." },
            { ornamentBuyPrice: 0 },
            { ornamentSellPrice: 0 }
          ],
          date: "loading..."
        },
        {
          data: [
            { barBuyPrice: 0 },
            { barPriceChange: 0 },
            { barSellPrice: 0 },
            { createdAt: "loading..." },
            { createdTime: "loading..." },
            { ornamentBuyPrice: 0 },
            { ornamentSellPrice: 0 }
          ],
          date: "loading..."
        },
        {
          data: [
            { barBuyPrice: 0 },
            { barPriceChange: 0 },
            { barSellPrice: 0 },
            { createdAt: "loading..." },
            { createdTime: "loading..." },
            { ornamentBuyPrice: 0 },
            { ornamentSellPrice: 0 }
          ],
          date: "loading..."
        }
      ],
      countEmpty: 0
    };
  },
  computed: {
    ...mapGetters("gold", ["getGoldHistoryList"]),
    getItems() {
      return this.items;
    }
  },
  async created() {
    // setTimeout(async () => {
    if (this.queryDate) {
      await this.findGoldTraderHistory(this.queryDate);
      this.items = this.getGoldHistoryList;
      let lastDate = this.queryDate;
      for (let i = 0; i < 5; i++) {
        let beforeLastDate = moment(lastDate)
          .subtract(1, "days")
          .format("YYYY-MM-DD");
        await this.findGoldTraderHistory(beforeLastDate);
        this.items = this.getGoldHistoryList;
        lastDate = beforeLastDate;
      }
    }
    // }, 1000);
  },
  watch: {
    getGoldHistoryList() {
      return this.getGoldHistoryList;
    }
  },
  filters: {
    currency: function(val) {
      let toNumber = parseFloat(val);
      return toNumber
        .toLocaleString("th", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    percent: function(val) {
      if (val > 0) {
        return "+" + parseFloat(val).toFixed(1) + " %";
      }

      return parseFloat(val).toFixed(1) + " %";
    },
    minusValue: function(val) {
      if (val < 0) {
        return parseFloat(val.replace("-", "")).toFixed(2);
      }

      return val;
    },
    parseTime(date) {
      return moment.utc(date).format("HH.mm");
    },
    formatThaiDateWithWeekDay(date) {
      let momentDate = moment(date).locale("th-TH");
      return momentDate.format("ddddที่ DD/MM/") + momentDate.add("543", "years").format("YYYY");
    },
    formatTime(date) {
      return moment.utc(date).format("HH.mm");
    }
  },
  methods: {
    ...mapActions("gold", ["findGoldTraderHistory"]),
    async infiniteHandler($state) {
      if (this.items.length <= this.getGoldHistoryList.length) {
        let lastDate = this.getItems[this.getItems.length - 1].date;
        let beforeLastDate = moment(lastDate)
          .subtract(1, "days")
          .format("YYYY-MM-DD");
        await this.findGoldTraderHistory(beforeLastDate);
        if (this.getItems[this.getItems.length - 1].data.length > 0) {
          this.items = this.getGoldHistoryList;
          setTimeout(() => {
            $state.loaded();
          }, 200);
          this.countEmpty = 0;
        } else {
          if (this.countEmpty < 8) {
            this.items = this.getGoldHistoryList;
            this.countEmpty++;
            setTimeout(() => {
              $state.loaded();
            }, 200);
          } else {
            $state.complete();
          }
        }
      } else {
        setTimeout(() => {
          $state.reset();
        }, 10000);
        $state.complete();
      }
    },
    isPriceChange(price) {
      if (price > 0) {
        return "fas fa-caret-up";
      } else if (price == 0) {
        return "fas fa-sort";
      } else return "fas fa-caret-down";
    },
    priceChangeColor(price) {
      if (price > 0) {
        return "plus";
      } else if (price == 0) {
        return "stable";
      } else return "minus";
    }
  }
};
</script>

<style lang="scss" scoped>
.null-percent {
  color: $color-secondary-text;
}

#gold-history-section {
  h2 {
    @extend %font-size-s;

    padding-top: 40px;
    padding-bottom: 8px;
  }
}
.gold-history-card {
  height: auto;
  background-color: $base-white;
  //   border: solid 1px #efefef;
  border-radius: 4px;
  box-shadow: 0 0 4px 0 rgba(186, 186, 186, 0.24), 0 0 6px 0 rgba(228, 232, 234, 0);
  .gold-card-content-history {
    // border-bottom: solid 1px #efefef;
    box-shadow: 0 0 4px 0 rgba(186, 186, 186, 0.048), 0 0 6px 0 rgba(117, 117, 117, 0);
    @extend %container-style;
    padding: 8px 16px;
    position: relative;
    .left {
      display: inline-block;
      @include finCol(4, 12, 0px, top, true, true);
    }
    .center {
      display: inline-block;
      @include finCol(4.4, 12, 0px, middle, true, true);
    }
    .right {
      display: inline-block;
      @include finCol(3.6, 12, 0px, middle, true, true);
      text-align: left;
    }
    .title-round {
      @extend %font-size-ss;
      color: $color-normal-text;
      display: inline-block;
    }
    .title {
      @extend %font-size-ss;
      color: $color-secondary-text;
      display: inline-block;
    }
    .content {
      .time {
        @extend %font-size-ss;
        color: $color-secondary;
        display: inline-block;
      }
      .price {
        @extend %font-size-s;
        display: inline-block;
      }
      .unit {
        padding-left: 3px;
        @extend %font-size-ss;
        color: $color-normal-text;
        display: inline-block;
      }
    }
    .price-change {
      @extend %font-size-ss;
      display: inline-block;
      i {
        margin: 0 4px 0 0;
      }
    }
    .minus {
      color: $color-minus;
    }
    .plus {
      color: $color-plus;
    }
    .stable {
      color: $color-stable;
    }
  }
}
</style>